import { motion } from 'motion/react';
import { FC, ReactElement } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import LogoIcon from '../Icons/LogoIcon';
import { elementsTransition } from '@/utils/gamePacks';
import LeftFixedShape from '../Host/Setup/BackgroundElements/LeftFixedShape';
import BottomLineElement from '../Host/Setup/BackgroundElements/BottomLineElement';
import CenterFixedShape from '../Host/Setup/BackgroundElements/CenterFixedShape';
import config from '@/config';

const Authlayout: FC = (): ReactElement => {
  const location = useLocation();
  const isSignIn = location.pathname.includes('/auth/sign-in');
  const currentUrl = window.location.hostname;
  const isTenant = currentUrl !== config.siteDomain;

  return (
    <motion.div
      className="relative min-h-screen w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="h-full w-full absolute z-0 overflow-y-auto bg-secondary-clementine-100">
        <div className="py-20 mx-20 md:mx-32 border-b border-neutral-200 flex items-center justify-between">
          <LogoIcon className="w-73 md:w-80 h-auto" />
          <div className="text-sm">
            <span className="text-body text-neutral-400 font-light">
              {isSignIn ? "Don't have an account? " : 'Already have an account? '}
            </span>
            <Link
              className="text-body text-pink-600 font-semibold"
              to={isSignIn ? (isTenant ? '/auth/sign-up' : '/auth/free-trial') : '/auth/sign-in'}
            >
              {isSignIn ? 'Sign Up' : 'Sign In'}
            </Link>
          </div>
        </div>

        <LeftFixedShape
          className="absolute top-135 left-0 origin-left"
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={elementsTransition}
        />

        <BottomLineElement
          className="absolute bottom-0 left-1/2 -translate-x-1/2 origin-bottom"
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={elementsTransition}
        />

        <div className="flex justify-center mt-48 md:mt-148 lg:mt-56 min-h-600 lg:min-h-0">
          <motion.div
            initial={{ opacity: 0, x: 150 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -150 }}
            key={location.pathname}
            className="px-20 w-full h-full min-h-600 md:min-h-0 md:mx-0 lg:w-full md:max-w-608 md:max-h-640 overflow-hidden lg:overflow-visible relative lg:static"
          >
            <Outlet />
            <CenterFixedShape
              className={`absolute lg:relative z-0 ${
                location.pathname.includes('/auth/sign-up')
                  ? 'top-190 lg:top-auto lg:bottom-320'
                  : 'top-190 lg:top-auto lg:bottom-105'
              } -right-180 lg:right-auto lg:left-340`}
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={elementsTransition}
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Authlayout;
